export default {"src":"/_next/static/media/stressMotivationMobile.baa408d4.svg","height":230,"width":272,"blurWidth":0,"blurHeight":0};